export const clientePorCpfPropostaKeys = {
  cliente: ['clientes-cpf-proposta'] as const,
  obter: (cpf: string) => [...clientePorCpfPropostaKeys.cliente, cpf],
}

export const clienteKeys = {
  cliente: ['cliente'] as const,
  lista: () => [...clienteKeys.cliente, 'lista'] as const,
  atualizar: () => [...clienteKeys.cliente, 'atualizar'] as const,
}

export const nacionalidadeClienteKeys = {
  nacionalidade: ['clientes-nacionalidade'] as const,
  lista: () => [...nacionalidadeClienteKeys.nacionalidade, 'lista'] as const,
}

export const profissaoClienteKeys = {
  profissao: ['clientes-profissao'] as const,
  lista: () => [...profissaoClienteKeys.profissao, 'lista'] as const,
}
